export const MODAL_OPEN_BODY_CLASS = "modal-is-open"

// Shared open/close/scroll-lock/animation logic for the app's slide-up (mobile) /
// fade-scale (desktop) modals. Element access is injected via getBackdrop/getModal
// so callers can use either fixed DOM ids or Stimulus targets.
export function createModalBehavior({ getBackdrop, getModal }) {
  let scrollPosition = 0
  let handleBackdropClick = null

  function isOpen() {
    const backdrop = getBackdrop()
    if (!backdrop) return false

    return !backdrop.classList.contains("hidden")
  }

  function releaseScrollLock() {
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.left = ""
    document.body.style.right = ""
    document.body.style.width = ""
    document.body.classList.remove("overflow-hidden")
  }

  function open({ before, onDesktopOpen, onMobileOpen } = {}) {
    const backdrop = getBackdrop()
    const modal = getModal()

    if (!backdrop || !modal) return

    if (before) before()

    // Remember scroll position!!
    scrollPosition = window.scrollY
    // Remove possibility to scroll backdrop
    document.body.style.position = "fixed"
    document.body.style.top = `-${scrollPosition}px`
    document.body.style.left = "0"
    document.body.style.right = "0"
    document.body.style.width = "100%"
    document.body.classList.add("overflow-hidden")

    backdrop.classList.remove("hidden")

    requestAnimationFrame(() => {
      backdrop.classList.remove("opacity-0")
      backdrop.classList.add("opacity-100")

      if (window.innerWidth >= 768) {
        // 💻 DESKTOP (fade + scale)
        modal.classList.remove("opacity-0", "scale-95")
        modal.classList.add("opacity-100", "scale-100")

        if (onDesktopOpen) onDesktopOpen()
      } else {
        // 📱 MOBILE (slide up)
        document.body.classList.add(MODAL_OPEN_BODY_CLASS)
        modal.classList.remove("translate-y-full")

        if (onMobileOpen) onMobileOpen()
      }
    })

    // bounce on backdrop click
    handleBackdropClick = (e) => {
      if (e.target === backdrop) {
        modal.classList.add("scale-105")
        setTimeout(() => {
          modal.classList.remove("scale-105")
        }, 150)
      }
    }

    backdrop.addEventListener("click", handleBackdropClick)
  }

  function close({ onComplete } = {}) {
    const backdrop = getBackdrop()
    const modal = getModal()

    if (!backdrop || !modal) return

    backdrop.classList.remove("opacity-100")
    backdrop.classList.add("opacity-0")

    if (window.innerWidth >= 768) {
      // 💻 DESKTOP
      modal.classList.remove("opacity-100", "scale-100")
      modal.classList.add("opacity-0", "scale-95")
    } else {
      // 📱 MOBILE
      document.body.classList.remove(MODAL_OPEN_BODY_CLASS)
      modal.classList.add("translate-y-full")
    }

    setTimeout(() => {
      backdrop.classList.add("hidden")

      releaseScrollLock()
      window.scrollTo(0, scrollPosition)

      if (handleBackdropClick) {
        backdrop.removeEventListener("click", handleBackdropClick)
        handleBackdropClick = null
      }

      if (onComplete) onComplete()
    }, 300)
  }

  function listenForSwipeClose(closeFn) {
    const handler = () => {
      if (isOpen()) (closeFn || close)()
    }
    document.addEventListener("swipe-back:close-modal", handler)
    return () => document.removeEventListener("swipe-back:close-modal", handler)
  }

  return { isOpen, open, close, releaseScrollLock, listenForSwipeClose }
}
